/*
 * 作者: Fultom
 * 创建时间: 2024-04-12 09:41:51
 * 最近修改时间: 2024-12-12 15:34:47
 * 功能: 
 */
import lianlian from './lianlian';
import membercontroller from './memberController';
import shoppingCart from './shoppingCart';
import noticeModule from './noticeModule';
import shareGoods from './shareGoods';
import afterSale from './afterSale';
import exchangeCenter from './exchangeCenter';
import public_ from './public';
import commonMember from './commonMember';
import agent from './agent';
import activity from './activity';
import live from './zhibo';
import dataPerformance from './dataPerformance'
export default {
  lianlian,
  membercontroller,
  shoppingCart,
  noticeModule,
  agent,
  shareGoods,
  exchangeCenter,
  commonMember,
  public_,
  afterSale,
  activity,
  dataPerformance,
  live
};



// WEBPACK FOOTER //
// ./src/request/api/index.js